import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Style from './index.css';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Mousewheel, Pagination, Keyboard } from 'swiper';
import PageIndex from '@src/pc/index/layout/PageIndex';
import Page1 from '@src/pc/index/layout/Page1';
import Page2 from '@src/pc/index/layout/Page2';
import Page3 from '@src/pc/index/layout/Page3';
// import Page4 from '@src/pc/index/layout/Page4';
import Float from '@src/pc/index/layout/Float';
import VideoMask from '@src/common/components/VideoMask';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';

const Layout = ({ content }) => {
    const { peopleList = [], config } = content;
    const peopleListNew = JSON.parse(JSON.stringify(peopleList)).reverse();
    const [swiperIndex, setSwiperIndex] = useState('1');
    const [maskVisible, setMaskVisible] = useState(false);
    const [currentVideo, setCurrentVideo] = useState({});
    const [isShowFloat, setIsShowFloat] = useState(false);
    const [peopleIndex, setPeopleIndex] = useState(-1);
    const swiperRef = useRef();
    const menuRef = useRef(-1);

    const slides = config.filter((a) => a.isShow && a.id.match(/[0-9]/g));

    useEffect(() => {
        // 设备宽度小于750跳到分享页
        if (window.screen.width < 750 && !window.location.href.includes('/visualediting')) {
            window.location.href = 'https://ishare.ifeng.com/c/s/8Kvves6nvQu';
        }
    }, []);

    const changePeopleAndSwiper = (index) => {
        if (!maskVisible) {
            setPeopleIndex(index);
            menuRef.current = index;

            if (index < 0) {
                // eslint-disable-next-line no-unused-expressions
                swiperRef.current?.slideTo(index + 1);
            } else {
                // eslint-disable-next-line no-unused-expressions
                swiperRef.current?.slideTo(1);
            }
        }
    };

    const changeIndexAndRef = (index) => {
        setPeopleIndex(index);
        menuRef.current = index;
    };

    return (
        <div className={Style.contain}>
            <div className={`${Style.peopleList} ${peopleIndex < 0 ? '' : Style.inPeople}`}>
                <div className={Style.first}>
                    <div className={`${Style.people} ${-1 === peopleIndex ? Style.active : ''}`} onClick={() => changePeopleAndSwiper(-1)}>
                        首页
                    </div>
                    <span className={Style.divider}>/</span>
                </div>
                {peopleListNew &&
                    peopleListNew.length &&
                    peopleListNew.map((people, index) => {
                        return (
                            <div key={index}>
                                <div className={`${Style.people} ${index === peopleIndex ? Style.active : ''}`} onClick={() => changePeopleAndSwiper(index)}>
                                    {people.name}
                                </div>
                                {index < peopleList.length - 1 && <span className={Style.divider}>/</span>}
                            </div>
                        );
                    })}
            </div>
            <Chip id="260492" type="struct" name="peopleList" title="人物列表" groupName="人物列表">
                <div className={Style.chip} />
            </Chip>
            {/* <Chip id="260504" type="struct" name="config" title="设置" groupName="设置">
                <div className={Style.chip} style={{ top: '40px' }} />
            </Chip> */}
            <Swiper
                className={Style.swiper}
                allowSlidePrev={!maskVisible}
                allowSlideNext={!maskVisible}
                direction="vertical"
                modules={[Scrollbar, Mousewheel, Pagination, Keyboard]}
                scrollbar={{
                    hide: true,
                }}
                simulateTouch={false}
                mousewheel={{
                    forceToAxis: true,
                }}
                speed={1500}
                keyboard={{
                    enabled: true,
                }}
                onSlideChange={(swiper) => {
                    setSwiperIndex(slides[swiper.realIndex].id);
                    if (swiper.realIndex === 0) {
                        setPeopleIndex(-1);
                        setIsShowFloat(false);
                    } else {
                        setPeopleIndex(menuRef.current > -1 ? menuRef.current : 0);
                        setIsShowFloat(true);
                    }
                }}
                onSwiper={(swiper) => (swiperRef.current = swiper)}>
                {config.find((a) => a.id === '1').isShow && (
                    <SwiperSlide>
                        <PageIndex config={config} peopleList={peopleList} onChangeMaskVisible={setMaskVisible} onChangeCurrentVideo={setCurrentVideo} onChangeFloat={setIsShowFloat} />
                    </SwiperSlide>
                )}
                {config.find((a) => a.id === '2').isShow && (
                    <SwiperSlide>
                        <Page1
                            config={config}
                            peopleList={peopleListNew}
                            onChangeMaskVisible={setMaskVisible}
                            onChangeCurrentVideo={setCurrentVideo}
                            onChangeFloat={setIsShowFloat}
                            peopleIndex={peopleIndex}
                            setPeopleIndex={changeIndexAndRef}
                            slideIndex={swiperIndex}
                        />
                    </SwiperSlide>
                )}
                {config.find((a) => a.id === '3').isShow && (
                    <SwiperSlide>
                        <Page2 peopleList={peopleList} index={menuRef.current > -1 ? menuRef.current : 0} onChangeCurrentVideo={setCurrentVideo} onChangeMaskVisible={setMaskVisible} />
                    </SwiperSlide>
                )}
                {config.find((a) => a.id === '4').isShow && (
                    <SwiperSlide>
                        <Page3 peopleList={peopleList} index={menuRef.current > -1 ? menuRef.current : 0} onChangeCurrentVideo={setCurrentVideo} onChangeMaskVisible={setMaskVisible} />
                    </SwiperSlide>
                )}
                {isShowFloat && (
                    <div className={Style.show}>
                        <Float slideIndex={swiperIndex} config={config} />
                    </div>
                )}
                <VideoMask visible={maskVisible} onChangeVisible={setMaskVisible} videoInfo={currentVideo} />
            </Swiper>
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
